import React from "react";
import ProductViewBox from "../../windows/Applets/ProductViewBox";
import Responsive from "../Responsive";
import HttpServices from "../../utils/Http.services";
import { imageAddress } from "../../utils/useful";
import BookingUserViewServices from "../../windows/Applets/booking/components/BookingUserViewServices";
import SingleSlider from "../slider/SingleSlider";
import MySlider from "../slider/MySlider";

class ProductSection extends React.Component {
    state = {
        services: [
            { name: 'test1', price: '100', priceSttings: { discount: { value: 10, type: 'cash' }, currency: '$', priceBeforeDiscount: '10' } },
            { name: 'test2', price: '100', priceSttings: { discount: { value: 10, type: 'cash' }, currency: '$', priceBeforeDiscount: '10' } },
            { name: 'test3', price: '100', priceSttings: { discount: { value: 10, type: 'cash' }, currency: '$', priceBeforeDiscount: '10' } },
            { name: 'test4', price: '100', priceSttings: { discount: { value: 10, type: 'cash' }, currency: '$', priceBeforeDiscount: '10' } },
            { name: 'test5', price: '100', priceSttings: { discount: { value: 10, type: 'cash' }, currency: '$', priceBeforeDiscount: '10' } },
        ],
        img: [
            {
                image: '/images/back/aleksandr-popov-V3snakBbbfY-unsplash.jpg',
                title: 'Product 1',
                description: 'Description for Product 1',
            },
            {
                image: '/images/back/aleksandr-popov-V3snakBbbfY-unsplash.jpg',
                title: 'Product 2',
                description: 'Description for Product 2',
            },
            {
                image: '/images/back/aleksandr-popov-V3snakBbbfY-unsplash.jpg',
                title: 'Product 3',
                description: 'Description for Product 3',
            },
            {
                image: '/images/back/aleksandr-popov-V3snakBbbfY-unsplash.jpg',
                title: 'Product 2',
                description: 'Description for Product 2',
            },
            {
                image: '/images/back/aleksandr-popov-V3snakBbbfY-unsplash.jpg',
                title: 'Product 3',
                description: 'Description for Product 3',
            },
        ]
    }

    serviceClicked = (link) => {
        this.props.changeWindow(link)
    }

    render() {
        return (
            <div className="dashboard-widgets" style={{ border: '3px solid #fff', }}>
                <div className=' pt-3 d-flex position-sticky pb-2 px-3' style={{ justifyContent: 'space-between' }}>

                    <div className="mb-2">
                        <p className='text-bold text-semibig '>Top Products</p>
                        <div className="flexc mt-2">
                            <div className="mrd-2 flexcc">
                                <img className="br-20" src={imageAddress('', 'profile')} style={{ height: 20, width: 20, objectFit: 'cover' }} />
                            </div>
                            <div className="flex-1 flexc ">
                                <p className='text-smaller '>Applet Name</p>
                                {/* <p className='text-smaller '>@Hub Name</p> */}
                            </div>
                        </div>
                    </div>

                </div>


                <div className='w-100 window-content-radius h-100 d-flex flex-column scroll-no-scrollbar' >
                    <MySlider addNewWindow={this.props.addNewWindow} items={this.state.services} />
                </div >

            </div >
        )
    }

}



export default ProductSection;